<template>
  <div class="classContainer">
    <van-nav-bar
      title="学员列表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="listBox">
      <van-search
        v-model="keyword"
        shape="round"
        placeholder="请输入姓名、工号、手机号搜索"
        clearable
        show-action
        @search="onSearch"
        @cancel="onCancel"
      />
      <div class="listBox-item" v-for="(item, index) in studentList" :key="item.id">
        <div class="left">
          <img src="@/assets/images/avatar.png" alt="" />
          <div class="content-info">
            <div class="name">
              {{item.realName}}
            </div>
            <div class="identity">
              {{item.className?item.className:'-'}}
            </div>
          </div>
        </div>
        <div class="right">{{ item.clockStatus==1?'已签到':'未签到' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { teachingStudent} from "@/api/classSchedule";

export default {
  name: "checkStudent",
  data() {
    return {
      planDetailId:'',
      planId:'',
      studentList:[],
      keyword: ''
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },
    async getStudentList(){
      let res = await teachingStudent({planId:this.planId,planDetailId:this.planDetailId,keyword:this.keyword});
      this.studentList = res.data;
    },
    onSearch(){
      this.getStudentList()
    },
    onCancel(){
      this.keywords = ''
      this.getStudentList()
    }
  },
  mounted() {
    this.planId = this.$route.query.planId;
    this.planDetailId = this.$route.query.planDetailId;
    this.getStudentList()
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.listBox {
  height: calc(100vh - 46px);
  overflow-y: auto;
  padding: 16px;
  padding-top: 0;

  .listBox-item {
    width: 341px;
    height: 80px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      height: 48px;
      display: flex;
      img {
        height: 48px;
        width: 48px;
      }
      .content-info {
        margin-left: 12px;
        .name {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 15px;
          color: #121212;
          line-height: 21px;
          font-style: normal;
        }
        .identity {
          margin-top: 6px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 18px;
          font-style: normal;
          max-width: 200px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #3776FF;
      .gray{
        color: #8F91A1;
      }
      // width: 32rpx;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
